/**
 * Trade application GTM tracking.
 *
 * Pushes successful application leads into window.dataLayer for Google Tag Manager.
 */
(function () {
  'use strict';

  const US_STATE_CODES = {
    'Alabama': 'AL',
    'Alaska': 'AK',
    'American Samoa': 'AS',
    'Arizona': 'AZ',
    'Arkansas': 'AR',
    'California': 'CA',
    'Colorado': 'CO',
    'Connecticut': 'CT',
    'Delaware': 'DE',
    'District of Columbia': 'DC',
    'Florida': 'FL',
    'Georgia': 'GA',
    'Guam': 'GU',
    'Hawaii': 'HI',
    'Idaho': 'ID',
    'Illinois': 'IL',
    'Indiana': 'IN',
    'Iowa': 'IA',
    'Kansas': 'KS',
    'Kentucky': 'KY',
    'Louisiana': 'LA',
    'Maine': 'ME',
    'Maryland': 'MD',
    'Massachusetts': 'MA',
    'Michigan': 'MI',
    'Minnesota': 'MN',
    'Mississippi': 'MS',
    'Missouri': 'MO',
    'Montana': 'MT',
    'Nebraska': 'NE',
    'Nevada': 'NV',
    'New Hampshire': 'NH',
    'New Jersey': 'NJ',
    'New Mexico': 'NM',
    'New York': 'NY',
    'North Carolina': 'NC',
    'North Dakota': 'ND',
    'Northern Mariana Islands': 'MP',
    'Ohio': 'OH',
    'Oklahoma': 'OK',
    'Oregon': 'OR',
    'Pennsylvania': 'PA',
    'Puerto Rico': 'PR',
    'Rhode Island': 'RI',
    'South Carolina': 'SC',
    'South Dakota': 'SD',
    'Tennessee': 'TN',
    'Texas': 'TX',
    'U.S. Virgin Islands': 'VI',
    'Utah': 'UT',
    'Vermont': 'VT',
    'Virginia': 'VA',
    'Washington': 'WA',
    'West Virginia': 'WV',
    'Wisconsin': 'WI',
    'Wyoming': 'WY',
  };

  function cleanObject(value) {
    const cleaned = {};

    Object.keys(value).forEach(function (key) {
      const fieldValue = value[key];

      if (fieldValue === undefined || fieldValue === null || fieldValue === '') {
        return;
      }

      if (typeof fieldValue === 'object' && !Array.isArray(fieldValue)) {
        const nested = cleanObject(fieldValue);
        if (Object.keys(nested).length > 0) {
          cleaned[key] = nested;
        }
        return;
      }

      cleaned[key] = fieldValue;
    });

    return cleaned;
  }

  function normalizeEmail(email) {
    const value = String(email || '').trim().toLowerCase();
    return value || undefined;
  }

  function normalizePhone(phone) {
    const value = String(phone || '').trim();
    if (!value) return undefined;

    const digits = value.replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    if (value.charAt(0) === '+' && digits) return '+' + digits;

    return value;
  }

  function normalizeRegion(region) {
    const value = String(region || '').trim();
    if (!value) return undefined;
    if (value.length <= 2) return value.toUpperCase();

    return US_STATE_CODES[value] || value;
  }

  function normalizeCountry(country) {
    const value = String(country || '').trim();
    if (!value) return undefined;
    if (value.length === 2) return value.toUpperCase();
    if (value === 'United States' || value === 'USA' || value === 'United States of America') return 'US';

    return value;
  }

  function getCustomerData() {
    const joinRoot = document.querySelector('[data-trade-join]');
    return joinRoot ? joinRoot.dataset : {};
  }

  window.pushTradeApplicationSignUp = function (applicationData, callback) {
    const data = applicationData || {};
    const address = data.address || {};
    const customerData = getCustomerData();
    const userData = cleanObject({
      email: normalizeEmail(data.email || customerData.customerEmail),
      phone: normalizePhone(data.phone),
      address: {
        first_name: data.firstName || customerData.customerFirstName,
        last_name: data.lastName || customerData.customerLastName,
        city: address.city,
        region: normalizeRegion(address.state || address.region),
        postal_code: address.zipPostalCode || address.postal_code,
        country: normalizeCountry(address.country),
      },
    });

    let callbackCalled = false;
    function complete() {
      if (callbackCalled) return;
      callbackCalled = true;
      if (typeof callback === 'function') callback();
    }

    const eventPayload = {
      event: 'sign_up',
      user_data: userData,
    };

    if (typeof callback === 'function') {
      eventPayload.eventCallback = complete;
      eventPayload.eventTimeout = 1500;
      window.setTimeout(complete, 1500);
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventPayload);
    } catch (error) {
      if (window.trackTradeError) {
        window.trackTradeError(error, { source: 'TradeApplicationTracking.push' });
      }
      complete();
    }
  };
})();
